import { Collapse, Col, Row } from "antd";
import { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { CollapseComponent } from "./Collapse";
import { ShowHide } from "./ShowHide";
const { Panel } = Collapse;

export const SubElementWithInput = ({
  data,
  separateTeensAdults,
  separateRole,
  showHourly,
  all,
  toUpdateDataElement,
  staffTime,
}) => {
  useEffect(() => {}, [separateTeensAdults, separateRole, showHourly]);

  const getContent = (data) => {
    var res = [];
    var resultat = [];
    var items = [];

    const toUpdateData = (id, parent, values) => {
      toUpdateDataElement(id, parent, values);
    };
    try {
      data[0].value.forEach((element) => {
        var i = 1;

        if (Array.isArray(element.value)) {
          element.value.forEach((sub) => {
            if (all || sub.display) {
              items.push(
                <Col xl={12} lg={12} md={24}>
                  <ShowHide
                    staffTime={staffTime}
                    suffix={sub.suffix}
                    prefix={sub.prefix}
                    separateTeensAdults={separateTeensAdults}
                    separateRole={separateRole}
                    showHourly={showHourly}
                    toUpdateForm={toUpdateForm}
                    //toUpdateRadio={toUpdateRadio}
                    showInput={true}
                    idOfTooltip={sub.fieldName + "Tooltip"}
                    value={sub.value}
                    activeElement={sub.display}
                    changedValue={
                      element.changedValue ? element.changedValue : ""
                    }
                    radio={false}
                    parent={element.fieldName}
                    id={sub.fieldName}
                    visible={sub.visible}
                    all={all}
                  />
                </Col>
              );
            }
            if (i % 2 == 0 || i == element.value.length) {
              res.push(<Row style={{ marginTop: "2vh" }}>{items}</Row>);
              items = [];
            }
            i++;
          });
        } else if (element.display || all) {
          items.push(
            <Col xl={12} lg={12} md={24}>
              <ShowHide
                staffTime={staffTime}
                suffix={element.suffix}
                prefix={element.prefix}
                separateTeensAdults={separateTeensAdults}
                separateRole={separateRole}
                showHourly={showHourly}
                toUpdateForm={toUpdateForm}
                toUpdateData={toUpdateData}
                showInput={true}
                changedValue={element.changedValue ? element.changedValue : ""}
                value={element.value}
                idOfTooltip={element.fieldName + "Tooltip"}
                activeElement={element.display}
                radio={false}
                id={element.fieldName}
                all={all}
              />
            </Col>
          );
          if (items.length == 2) {
            res.push(
              <Row style={{ marginTop: "2vh", padding: "16px " }}>{items}</Row>
            );
            items = [];
          }
        }
        if (all || shouldAdd(element)) {
          if (Array.isArray(element.value)) {
            resultat.push(
              <Collapse defaultActiveKey={["1"]}>
                <Panel
                  header={
                    <Row className="dashed" style={{ marginTop: "2vh" }}>
                      <span className=" roi--second-collapse-title">
                        <FormattedMessage id={element.fieldName} />
                      </span>
                    </Row>
                  }
                  key="1"
                >
                  <>{res}</>
                </Panel>
              </Collapse>
            );
          } else {
            resultat.push(res);
          }
        }
        res = [];
      });
    } catch (error) {
      console.log("err", error);
    }
    return resultat;
  };

  const toUpdateForm = (id, parent, values) => {
    toUpdateDataElement(id, parent, values);
  };

  const shouldAdd = (element) => {
    var res = false;
    if (Array.isArray(element.value)) {
      element.value.forEach((sub) => {
        if (Array.isArray(sub.value) && sub.display) {
          sub.value.forEach((x) => {
            if (x.display) {
              res = true;
            }
          });
        } else if (sub.display) {
          res = true;
        }
      });
    } else {
      return element.display;
    }
    return res;
  };

  const getValue = (array, field) => {
    if (separateTeensAdults) {
      return null != array.filter((a) => a.fieldName == "teens")[0]
        ? array.filter((a) => a.fieldName == "teens")[0].value
        : "";
    } else {
      return null != array.filter((a) => a.fieldName == "adults")[0]
        ? array.filter((a) => a.fieldName == "adults")[0].value
        : "";
    }
  };

  return (
    <>
      <CollapseComponent
        style={{ marginBottom: "2vh", marginTop: "2vh" }}
        headerText={<FormattedMessage id={data[0].fieldName} />}
        classNameHeader="roi--collapse-header-green"
        content={getContent(data)}
      ></CollapseComponent>
    </>
  );
};
